export default __webpack_public_path__ + "images/advanced-thinking-skills.svg";